import React from "react";
import * as style from "./styles.module.scss";

const PulseBallLoader = () => {
  return (
    <div className={`${style.laBallScalePulse} ${style.laDark} ${style.la3x}`}>
      <p>loading...</p>
      <div></div>
      <div></div>
    </div>
  );
};

export default PulseBallLoader;
